/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Refund totals in financials response
 * @export
 * @interface FinancialsRefunds
 */
export interface FinancialsRefunds {
    /**
     * 
     * @type {number}
     * @memberof FinancialsRefunds
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialsRefunds
     */
    total?: number;
}

/**
 * Check if a given object implements the FinancialsRefunds interface.
 */
export function instanceOfFinancialsRefunds(value: object): value is FinancialsRefunds {
    return true;
}

export function FinancialsRefundsFromJSON(json: any): FinancialsRefunds {
    return FinancialsRefundsFromJSONTyped(json, false);
}

export function FinancialsRefundsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialsRefunds {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function FinancialsRefundsToJSON(json: any): FinancialsRefunds {
    return FinancialsRefundsToJSONTyped(json, false);
}

export function FinancialsRefundsToJSONTyped(value?: FinancialsRefunds | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'total': value['total'],
    };
}

